export default __webpack_public_path__ + "static/rocket_bw_small_2-01b031a2c187d90e4b4458db27f75316.mp4";